"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const classTransformer_1 = require("../classTransformer");
const class_validator_1 = require("class-validator");
const Resource_1 = __importDefault(require("../Resource"));
const DocumentType_1 = __importDefault(require("./DocumentType"));
const Office_1 = __importDefault(require("./Office"));
class DocumentRemindersConfig extends Resource_1.default {
}
exports.default = DocumentRemindersConfig;
__decorate([
    (0, classTransformer_1.Expose)(),
    (0, class_validator_1.IsOptional)(),
    __metadata("design:type", String)
], DocumentRemindersConfig.prototype, "uid", void 0);
__decorate([
    (0, classTransformer_1.Expose)(),
    (0, class_validator_1.IsNotEmpty)({ message: "Document type is required" }),
    (0, classTransformer_1.Type)(() => DocumentType_1.default),
    __metadata("design:type", DocumentType_1.default)
], DocumentRemindersConfig.prototype, "document_type", void 0);
__decorate([
    (0, classTransformer_1.Expose)(),
    (0, class_validator_1.IsOptional)(),
    __metadata("design:type", String)
], DocumentRemindersConfig.prototype, "document_type_uid", void 0);
__decorate([
    (0, classTransformer_1.Expose)(),
    (0, class_validator_1.IsNotEmpty)({ message: "Office is required" }),
    (0, classTransformer_1.Type)(() => Office_1.default),
    __metadata("design:type", Office_1.default)
], DocumentRemindersConfig.prototype, "office", void 0);
__decorate([
    (0, classTransformer_1.Expose)(),
    (0, class_validator_1.IsOptional)(),
    __metadata("design:type", String)
], DocumentRemindersConfig.prototype, "office_uid", void 0);
__decorate([
    (0, classTransformer_1.Expose)(),
    (0, class_validator_1.IsNotEmpty)({ message: "Reminder intervals are required" }),
    (0, class_validator_1.IsArray)(),
    (0, class_validator_1.IsInt)({ each: true }),
    __metadata("design:type", Array)
], DocumentRemindersConfig.prototype, "reminder_intervals", void 0);
__decorate([
    (0, classTransformer_1.Expose)(),
    (0, class_validator_1.IsOptional)(),
    (0, class_validator_1.IsString)(),
    __metadata("design:type", String)
], DocumentRemindersConfig.prototype, "reminder_message", void 0);
__decorate([
    (0, classTransformer_1.Expose)(),
    (0, class_validator_1.IsOptional)(),
    (0, class_validator_1.IsBoolean)(),
    __metadata("design:type", Boolean)
], DocumentRemindersConfig.prototype, "auto_send", void 0);
__decorate([
    (0, classTransformer_1.Expose)(),
    (0, class_validator_1.IsOptional)(),
    (0, class_validator_1.IsBoolean)(),
    __metadata("design:type", Boolean)
], DocumentRemindersConfig.prototype, "is_active", void 0);
__decorate([
    (0, classTransformer_1.Expose)(),
    (0, class_validator_1.IsOptional)(),
    (0, class_validator_1.IsDate)(),
    (0, classTransformer_1.Type)(() => Date),
    __metadata("design:type", Date)
], DocumentRemindersConfig.prototype, "created_at", void 0);
__decorate([
    (0, classTransformer_1.Expose)(),
    (0, class_validator_1.IsOptional)(),
    (0, class_validator_1.IsDate)(),
    (0, classTransformer_1.Type)(() => Date),
    __metadata("design:type", Date)
], DocumentRemindersConfig.prototype, "updated_at", void 0);
